import { useEffect } from 'react';

import usePageTitle from '@hooks/usePageTitle/usePageTitle';
import { usePageContext } from '@providers/PageMetaProvider/model/PageContext';
import SettingsUsersTable from '@features/settings-users/containers/SettingsUsersTable';

const pageValues = {
  title: 'Users',
  description: 'Manage your company users here',
};

function SettingsUsersPage() {
  usePageTitle('ZlaytAI - Company Users');
  const { setValues } = usePageContext();

  useEffect(() => {
    if (setValues) {
      setValues((prev) => ({
        ...prev,
        ...pageValues,
      }));
    }
  }, []);

  return <SettingsUsersTable />;
}

export default SettingsUsersPage;
